import React from 'react'
import { isMobile } from '@manychat/manyui'

export default function MobileWarning() {
  if (!isMobile) {
    return null
  }

  return (
    <div className="text-white bg-warning text-sm p-a m-b">
      <strong className="text-white">Warning!</strong> Unfortunately, only Live Chat is optimized
      for mobile devices at the moment. Please use a desktop version for everything else.
    </div>
  )
}
